import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G6_P2_S1_Title: {
    id: `guide06.page02.slide01.title`,
  },
  G6_P2_S1_Description: {
    id: `guide06.page02.slide01.description`,
  },
  G6_P2_S2_Title: {
    id: `guide06.page02.slide02.title`,
  },
  G6_P2_S2_Description: {
    id: `guide06.page02.slide02.description`,
  },
});
